import React from 'react'
import VipLayout from '../../components/vip/VipLayout'

const VipProcessPage: React.FC = () => {
  return (
    <VipLayout>
      <section className="hero">
        <div className="container">
          <span className="kicker">Process</span>
          <h1>办理流程</h1>
          <p>从需求识别到申报辅导，再到后续支持，尽可能让项目推进更清晰、更可控。</p>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <table className="card" style={{padding: '10px'}}>
            <tbody>
              <tr>
                <th>阶段</th>
                <th>说明</th>
                <th>输出</th>
              </tr>
              <tr>
                <td>需求沟通</td>
                <td>了解企业主体、业务模式、产品形态与当前阶段。</td>
                <td>基础需求清单</td>
              </tr>
              <tr>
                <td>路径判断</td>
                <td>判断所需资质、备案或许可证，梳理适用性边界。</td>
                <td>路径判断意见</td>
              </tr>
              <tr>
                <td>材料清单</td>
                <td>列出所需资料、企业需配合事项与补充说明项。</td>
                <td>材料准备清单</td>
              </tr>
              <tr>
                <td>方案制定</td>
                <td>形成项目推进方案、时间安排与关键风险提示。</td>
                <td>服务方案</td>
              </tr>
              <tr>
                <td>申报辅导</td>
                <td>协助材料整理、系统填报、页面整改与申报说明。</td>
                <td>申报材料包</td>
              </tr>
              <tr>
                <td>审核跟进</td>
                <td>配合补正、问询回复、口径统一与后续支持。</td>
                <td>补正与答复支持</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </VipLayout>
  )
}

export default VipProcessPage
